export default function CancelOrderIcon(props) {
  return (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"{...props}>
      <path d="M8.33268 1.66669L1.66602 8.33335M1.66602 1.66669L8.33268 8.33335" stroke="#0F4262" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

  )
}
